/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      StoreLocations {
        nextToken
        __typename
      }
      BusinessEntities {
        nextToken
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      StoreLocations {
        nextToken
        __typename
      }
      BusinessEntities {
        nextToken
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      StoreLocations {
        nextToken
        __typename
      }
      BusinessEntities {
        nextToken
        __typename
      }
      role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBusinessEntity = /* GraphQL */ `
  mutation CreateBusinessEntity(
    $input: CreateBusinessEntityInput!
    $condition: ModelBusinessEntityConditionInput
  ) {
    createBusinessEntity(input: $input, condition: $condition) {
      id
      BusinessEntityStaff {
        nextToken
        __typename
      }
      BusinessEntityStoreLocation {
        nextToken
        __typename
      }
      name
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBusinessEntity = /* GraphQL */ `
  mutation UpdateBusinessEntity(
    $input: UpdateBusinessEntityInput!
    $condition: ModelBusinessEntityConditionInput
  ) {
    updateBusinessEntity(input: $input, condition: $condition) {
      id
      BusinessEntityStaff {
        nextToken
        __typename
      }
      BusinessEntityStoreLocation {
        nextToken
        __typename
      }
      name
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBusinessEntity = /* GraphQL */ `
  mutation DeleteBusinessEntity(
    $input: DeleteBusinessEntityInput!
    $condition: ModelBusinessEntityConditionInput
  ) {
    deleteBusinessEntity(input: $input, condition: $condition) {
      id
      BusinessEntityStaff {
        nextToken
        __typename
      }
      BusinessEntityStoreLocation {
        nextToken
        __typename
      }
      name
      users {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStoreLocation = /* GraphQL */ `
  mutation CreateStoreLocation(
    $input: CreateStoreLocationInput!
    $condition: ModelStoreLocationConditionInput
  ) {
    createStoreLocation(input: $input, condition: $condition) {
      id
      StoreLocationActivityLogs {
        nextToken
        __typename
      }
      name
      businessentityID
      physicalAddress
      users {
        nextToken
        __typename
      }
      timezone
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStoreLocation = /* GraphQL */ `
  mutation UpdateStoreLocation(
    $input: UpdateStoreLocationInput!
    $condition: ModelStoreLocationConditionInput
  ) {
    updateStoreLocation(input: $input, condition: $condition) {
      id
      StoreLocationActivityLogs {
        nextToken
        __typename
      }
      name
      businessentityID
      physicalAddress
      users {
        nextToken
        __typename
      }
      timezone
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStoreLocation = /* GraphQL */ `
  mutation DeleteStoreLocation(
    $input: DeleteStoreLocationInput!
    $condition: ModelStoreLocationConditionInput
  ) {
    deleteStoreLocation(input: $input, condition: $condition) {
      id
      StoreLocationActivityLogs {
        nextToken
        __typename
      }
      name
      businessentityID
      physicalAddress
      users {
        nextToken
        __typename
      }
      timezone
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStaff = /* GraphQL */ `
  mutation CreateStaff(
    $input: CreateStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    createStaff(input: $input, condition: $condition) {
      id
      name
      StaffActivityLogs {
        nextToken
        __typename
      }
      businessentityID
      hourlyRate
      pin
      phoneNumber
      email
      department
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStaff = /* GraphQL */ `
  mutation UpdateStaff(
    $input: UpdateStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    updateStaff(input: $input, condition: $condition) {
      id
      name
      StaffActivityLogs {
        nextToken
        __typename
      }
      businessentityID
      hourlyRate
      pin
      phoneNumber
      email
      department
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStaff = /* GraphQL */ `
  mutation DeleteStaff(
    $input: DeleteStaffInput!
    $condition: ModelStaffConditionInput
  ) {
    deleteStaff(input: $input, condition: $condition) {
      id
      name
      StaffActivityLogs {
        nextToken
        __typename
      }
      businessentityID
      hourlyRate
      pin
      phoneNumber
      email
      department
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createActivityLog = /* GraphQL */ `
  mutation CreateActivityLog(
    $input: CreateActivityLogInput!
    $condition: ModelActivityLogConditionInput
  ) {
    createActivityLog(input: $input, condition: $condition) {
      id
      createdAt
      storelocationID
      staffID
      type
      saleAmountCard
      saleAmountCash
      commissionAmountCard
      commissionAmountCash
      tipAmountCard
      tipAmountCash
      giftCardAmount
      depositAmount
      updatedAt
      __typename
    }
  }
`;
export const updateActivityLog = /* GraphQL */ `
  mutation UpdateActivityLog(
    $input: UpdateActivityLogInput!
    $condition: ModelActivityLogConditionInput
  ) {
    updateActivityLog(input: $input, condition: $condition) {
      id
      createdAt
      storelocationID
      staffID
      type
      saleAmountCard
      saleAmountCash
      commissionAmountCard
      commissionAmountCash
      tipAmountCard
      tipAmountCash
      giftCardAmount
      depositAmount
      updatedAt
      __typename
    }
  }
`;
export const deleteActivityLog = /* GraphQL */ `
  mutation DeleteActivityLog(
    $input: DeleteActivityLogInput!
    $condition: ModelActivityLogConditionInput
  ) {
    deleteActivityLog(input: $input, condition: $condition) {
      id
      createdAt
      storelocationID
      staffID
      type
      saleAmountCard
      saleAmountCash
      commissionAmountCard
      commissionAmountCash
      tipAmountCard
      tipAmountCash
      giftCardAmount
      depositAmount
      updatedAt
      __typename
    }
  }
`;
export const createUserStoreLocation = /* GraphQL */ `
  mutation CreateUserStoreLocation(
    $input: CreateUserStoreLocationInput!
    $condition: ModelUserStoreLocationConditionInput
  ) {
    createUserStoreLocation(input: $input, condition: $condition) {
      id
      userId
      storeLocationId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      storeLocation {
        id
        name
        businessentityID
        physicalAddress
        timezone
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserStoreLocation = /* GraphQL */ `
  mutation UpdateUserStoreLocation(
    $input: UpdateUserStoreLocationInput!
    $condition: ModelUserStoreLocationConditionInput
  ) {
    updateUserStoreLocation(input: $input, condition: $condition) {
      id
      userId
      storeLocationId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      storeLocation {
        id
        name
        businessentityID
        physicalAddress
        timezone
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserStoreLocation = /* GraphQL */ `
  mutation DeleteUserStoreLocation(
    $input: DeleteUserStoreLocationInput!
    $condition: ModelUserStoreLocationConditionInput
  ) {
    deleteUserStoreLocation(input: $input, condition: $condition) {
      id
      userId
      storeLocationId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      storeLocation {
        id
        name
        businessentityID
        physicalAddress
        timezone
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserBusinessEntity = /* GraphQL */ `
  mutation CreateUserBusinessEntity(
    $input: CreateUserBusinessEntityInput!
    $condition: ModelUserBusinessEntityConditionInput
  ) {
    createUserBusinessEntity(input: $input, condition: $condition) {
      id
      userId
      businessEntityId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      businessEntity {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserBusinessEntity = /* GraphQL */ `
  mutation UpdateUserBusinessEntity(
    $input: UpdateUserBusinessEntityInput!
    $condition: ModelUserBusinessEntityConditionInput
  ) {
    updateUserBusinessEntity(input: $input, condition: $condition) {
      id
      userId
      businessEntityId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      businessEntity {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserBusinessEntity = /* GraphQL */ `
  mutation DeleteUserBusinessEntity(
    $input: DeleteUserBusinessEntityInput!
    $condition: ModelUserBusinessEntityConditionInput
  ) {
    deleteUserBusinessEntity(input: $input, condition: $condition) {
      id
      userId
      businessEntityId
      user {
        id
        role
        createdAt
        updatedAt
        __typename
      }
      businessEntity {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
